import { useEffect, useState } from "react";
import api from "@/lib/api";
import Layout, { PageHeader } from "@/components/Layout";

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)); }, []);

  return (
    <Layout>
      <PageHeader title="Log Audit" subtitle="Jejak audit seluruh perubahan (tidak dapat dihapus)" breadcrumb="Audit OS · Admin" />
      <div className="p-6">
        <div className="bg-white border border-border rounded-sm overflow-x-auto">
          <table className="w-full audit-table">
            <thead><tr><th>Waktu</th><th>Aksi</th><th>Entitas</th><th>Detail</th><th>Pengguna</th><th>Peran</th></tr></thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} data-testid={`log-row-${l.id}`}>
                  <td className="font-mono text-xs whitespace-nowrap">{new Date(l.at).toLocaleString("id-ID")}</td>
                  <td><span className="text-[11px] px-1.5 py-0.5 border rounded-sm bg-muted font-medium">{l.action || l.type}</span></td>
                  <td>{l.entity || (l.type === "AI_DECISION" ? "AI" : "-")}</td>
                  <td className="text-muted-foreground">{l.detail || l.feature || ""} {l.decision ? `→ ${l.decision}` : ""}</td>
                  <td>{l.user}</td>
                  <td className="text-xs text-muted-foreground">{l.user_role}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
